import { render, staticRenderFns } from "./detailTitleContent.vue?vue&type=template&id=4a3c64ba&scoped=true"
import script from "./detailTitleContent.vue?vue&type=script&lang=js"
export * from "./detailTitleContent.vue?vue&type=script&lang=js"
import style0 from "./detailTitleContent.vue?vue&type=style&index=0&id=4a3c64ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c64ba",
  null
  
)

export default component.exports